import {
  Card,
  CardContent,
  Grid,
  List,
  ListItem,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";

const AboutPage = () => (
  <Stack spacing={4}>
    <Stack spacing={1.5}>
      <Typography variant="h3">About SmartPower</Typography>
      <Typography color="text.secondary" maxWidth={700}>
        SmartPower Solutions Corporation has supported energy consulting
        engagements since 2012 and was formally established in 2014 by power
        industry engineers. The team focuses on helping organizations improve
        competitiveness through practical, cost-efficient energy solutions and
        tailored services.
      </Typography>
    </Stack>

    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <Card
          sx={{
            height: "100%",
            border: "1px solid rgba(13, 27, 42, 0.06)",
            background: "rgba(255, 255, 255, 0.95)",
          }}
        >
          <CardContent>
            <Typography variant="h5" gutterBottom>
              Who We Are
            </Typography>
            <Typography color="text.secondary">
              SmartPower delivers customized energy solutions for diverse
              industries and project sizes. Their work emphasizes innovation,
              reliability, and long-term customer value through engineering
              expertise and collaborative delivery.
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} md={6}>
        <Card
          sx={{
            height: "100%",
            border: "1px solid rgba(13, 27, 42, 0.06)",
            background: "rgba(255, 255, 255, 0.95)",
          }}
        >
          <CardContent>
            <Typography variant="h5" gutterBottom>
              What We Do
            </Typography>
            <Typography color="text.secondary" gutterBottom>
              Services span energy consulting, distribution utility support, and
              electrical engineering services focused on efficiency and system
              reliability.
            </Typography>
            <List dense>
              <ListItem disableGutters>
                <ListItemText primary="Energy consulting, procurement, and audits" />
              </ListItem>
              <ListItem disableGutters>
                <ListItemText primary="Distribution utility planning and power quality" />
              </ListItem>
              <ListItem disableGutters>
                <ListItemText primary="Power system analysis and electrical maintenance" />
              </ListItem>
              <ListItem disableGutters>
                <ListItemText primary="Load profiling, thermographic inspection, and training" />
              </ListItem>
            </List>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  </Stack>
);

export default AboutPage;
